import * as React from 'react';
import { MessageBar, MessageBarType } from '@fluentui/react';
interface SuccessMessageProps {
  // tslint:disable-next-line:no-any
  children: any;
  onDismiss?: () => void;
  focusOnMount?: boolean;
  containerClassName?: string;
  className?: string;
  closeMessageAriaLabel?: string;
  isMultiLine?: boolean;
}

export class SuccessMessage extends React.Component<SuccessMessageProps> {
  private SuccessMessageRef: HTMLDivElement;

  componentDidMount() {
    if (this.SuccessMessageRef && this.props.focusOnMount) {
      this.SuccessMessageRef.focus();
    }
  }

  render() {
    return (
      <div
        tabIndex={-1}
        ref={(ref: HTMLDivElement) => (this.SuccessMessageRef = ref)}
        className={this.props.containerClassName}>
        <MessageBar
          className={`Success-padding-top ${this.props.className}`}
          dismissButtonAriaLabel={''}
          messageBarType={MessageBarType.success}
          onDismiss={this.props.onDismiss}
          isMultiline={this.props.isMultiLine}>
          {this.props.children}
        </MessageBar>
      </div>
    );
  }
}
